export default {
  /////////////////
  // COMPANY OBJECTS
  /////////////////

  SET_COMPANY_OBJECTS2(state, objects) {
    state.company_object = objects
  },

  SET_COMPANY_OBJECTS(state, objects) {
    state.objects = objects
  },
  SET_FILTER(state, objects) {
    state.filters = objects
  },

  SET_COMPANY_OBJECTS_MAP(state, objects) {
    state.objectsMap = objects
  },
  ADD_COMPANY_OBJECTS(state, objects) {
    state.objects.push(objects)
  },
  EDIT_COMPANY_OBJECTS(state, value) {
    const userIndex = state.objects.findIndex((u) => u.id === value.id)
    state.objects.splice(userIndex, 1, value)
  },

  /////////////////
  // POLLUTION_SOURCE
  /////////////////

  SET_POLLUTION_SOURCE_OBJECTS(state, source) {
    state.pollutionSources = source
  },
  SET_MONITORING_OBJECT(state, value) {
    state.newChartValue = value
  },
  SET_POLLUTION_SOURCE_OBJECTS_DIAGRAMS(state, value) {
    state.pollutionSourcesDiagrams = value
  },
  // SET_ALL_POLLUTION_SOURCE_OBJECTS(state, source) {
  //   state.pollutionSources = source
  // },
  ADD_POLLUTION_SOURCE_OBJECTS(state, source) {
    state.pollutionSources.push(source)
  },
  EDIT_POLLUTION_SOURCE_OBJECTS(state, value) {
    const userIndex = state.pollutionSources.findIndex((u) => u.id === value.id)
    state.pollutionSources.splice(userIndex, 1, value)
  },

  /////////////////
  // POLLUTION_SOURCE_NORMATIVE
  /////////////////

  // Пока не надо
  SET_POLLUTION_SOURCE_NORMATIVE(state, normative) {
    const normativeSourceIndex = state.pollutionSources.findIndex((u) => u.id === normative.source_id)
    state.pollutionSources[normativeSourceIndex].pollutionSourceNormatives.push(...normative.data)
  },
  SET_SELECT_POLLUTION_SOURCE_NORMATIVE(state, normative) {
    // console.log('normative', normative)
    state.selectPollutionSourcesList = normative.map(n => {
      return {
        id: n.id,
        name: n.component_name + ' [' + n.id + ']'
      }
    })
  },
  SET_ALL_POLLUTION_SOURCE_NORMATIVE(state, normative) {
    state.pollutionSourceNormatives = normative
  },
  // !Пока не надо


  ADD_POLLUTION_SOURCE_NORMATIVE(state, normative) {
    const normativeSourceIndex = state.pollutionSources.findIndex((u) => u.id === normative.source_id) //ищу источник в store
    if (!state.pollutionSources[normativeSourceIndex].component_normative) {
      state.pollutionSources[normativeSourceIndex].component_normative = []
      state.pollutionSources[normativeSourceIndex].component_normative.push(normative.data)
    } else {
      state.pollutionSources[normativeSourceIndex].component_normative.push(normative.data)
    }
  },
  EDIT_POLLUTION_SOURCE_NORMATIVE(state, normative) {
    const sourceIndex = state.pollutionSources.findIndex((u) => u.id === normative.source_id) //ищу источник в store
    const normativeSourceIndex = state.pollutionSources[sourceIndex].component_normative.findIndex((u) => u.id === normative.data.id) //ищу норматив в найденном источнике
    state.pollutionSources[sourceIndex].component_normative.splice(normativeSourceIndex, 1, normative.data)
  },
  DELETE_POLLUTION_SOURCE_NORMATIVE(state, normative) {
    const sourceIndex = state.pollutionSources.findIndex((u) => u.id === normative.source_id) //ищу источник в store
    const normativeSourceIndex = state.pollutionSources[sourceIndex].component_normative.findIndex((u) => u.id === normative.data.id) //ищу норматив в найденном источнике
    state.pollutionSources[sourceIndex].component_normative.splice(normativeSourceIndex, 1)
  },
  SET_SELECT_OBJECT_SOURCES_LIST(state, list) {
    state.pollutionSourcesSelectList = list
  },
  SET_OBJECT_POLLUTION_SOURCE_NORMATIVE_CHARTS(state, list) {
    state.pollutionSourceNormativeCharts = list
  },
  SET_OBJECT_COUNT_COMPANY_REGION(state, payload) {
    state.countCompanyRegion = payload
  },


  // SET_SELECT_LIST
  SET_NULL_SELECT_LIST(state) {
    state.setSelectList = {
      data: [],
      count: 0
    }
  },
  SET_SELECT_LIST(state, data) {
    state.setSelectList = {
      ...data,
      data: [...state.setSelectList.data, ...data.data],
    }
  },
}
